import React from 'react'
import { Fragment } from 'react'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'
import Footer from '../../component/Other/Footer'
import FormContact from '../../component/Other/FormContact'

const ServiceDetail = () => {
    const listMenu = [
        "Plant Rentals",
        "Custom Plant Design",
        "Plant Maintenance",
        "Green Wall Installation",
        "Plant Delivery",
        "Plant Consultation",
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Detail Service"} to={"Detail Service"} />
                </div>

                <section className='mb-5'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-xl-3 d-none d-md-block">
                                <div className="wrapper__list-detail">
                                    {
                                        listMenu.map((obj, i) => {
                                            return <div className="items">
                                                <div className={"label " + (i == 0 ? "active" : "")}>
                                                    <span className='semi-bold font__size-20 text__20-1024'>{obj}</span>
                                                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.6666 8.50004C10.6671 8.58778 10.6503 8.67475 10.6171 8.75598C10.584 8.8372 10.5351 8.91108 10.4733 8.97337L6.47329 12.9734C6.34776 13.0989 6.1775 13.1694 5.99996 13.1694C5.82243 13.1694 5.65216 13.0989 5.52663 12.9734C5.40109 12.8478 5.33057 12.6776 5.33057 12.5C5.33057 12.3225 5.40109 12.1522 5.52663 12.0267L9.05996 8.50004L5.53329 4.97337C5.42408 4.84584 5.36701 4.68179 5.37349 4.514C5.37997 4.34622 5.44952 4.18706 5.56825 4.06833C5.68698 3.9496 5.84614 3.88005 6.01393 3.87357C6.18171 3.86708 6.34576 3.92415 6.47329 4.03337L10.4733 8.03337C10.5965 8.15755 10.6659 8.32515 10.6666 8.50004Z" fill="white" />
                                                    </svg>
                                                </div>
                                            </div>
                                        })
                                    }

                                </div>
                            </div>
                            <div className="col-md-8 offset-xl-1">
                                <h2 className='normal font__size--40 text__40-1024 text__40-md text__40-mm mb-4'>Plant Rentals</h2>

                                <img src="./../images/dfsdfd.png" className='w-100 images__service-plant mb-4' alt="" />

                                <p className='normal font__size--14 text__14-1024 color__gray-1 mb-3'>Welcome to our plant rental service! We offer a wide variety of indoor plants to help bring life and vibrancy to your home or office space. Our rental service makes it easy for you to enjoy the benefits of plants without the long-term commitment of purchasing them.</p>
                                <p className='normal font__size--14 text__14-1024 color__gray-1 mb-3'>Our plant rental service includes a selection of high-quality, low-maintenance plants that are perfect for any indoor environment. From small desk plants to large statement pieces, we have a range of options to suit your needs. Our plants are sourced from local growers and are carefully chosen for their health and beauty.</p>
                                <p className='normal font__size--14 text__14-1024 color__gray-1 mb-3'>We offer flexible rental terms to fit your schedule and budget. Whether you need plants for a day, a week, or several months, we can create a rental plan that works for you. Our team will work with you to choose the best plants for your space and provide maintenance and care instructions to ensure they thrive.</p>
                                <p className='normal font__size--14 text__14-1024 color__gray-1 mb-3'>Our rental service includes delivery, setup, and pickup, so you don't have to worry about a thing. We take care of all the details so you can enjoy your plants without any hassle. Plus, our rental service is environmentally friendly - when your rental period is over, we'll pick up the plants and make sure they're reused or recycled.</p>
                                <p className='normal font__size--14 text__14-1024 color__gray-1'>If you're interested in renting plants for your home or office, please contact us to learn more. We'll be happy to answer any questions you have and create a rental plan that's tailored to your needs.</p>


                                <hr className='hr__footer my-5 opacity__2' />

                                <FormContact />

                            </div>
                        </div>
                    </div>
                </section>

                <SecContact />

                <Footer />
            </div>
        </Fragment>
    )
}

export default ServiceDetail